import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, switchMap, map } from 'rxjs/operators';
import {
    getPriorContractMetadata,
    getPriorContractMetadataSuccess,
    getPriorContractMetadataFailure
} from 'src/app/compliance/store/actions/compliance-metadata.actions';
import { MetadataClient } from 'src/app/compliance/api/metadata-client.service';

@Injectable()
export class ComplianceMetadataEffects {
    constructor(
        private readonly _actions$: Actions,
        private readonly _metadataClient: MetadataClient
    ) {}

    getPriorContractMetadata$ = createEffect(() =>
        this._actions$.pipe(
            ofType(getPriorContractMetadata),
            switchMap((action) => {
                return this._metadataClient
                    .getNotUserDefinedMetadataFieldsByContract(
                        action.contractId,
                        action.documentTypeId,
                        action.candidateDocumentId
                    )
                    .pipe(
                        map((result) => getPriorContractMetadataSuccess({ result })),
                        catchError((error: unknown) => of(getPriorContractMetadataFailure({ error })))
                    );
            })
        )
    );
}
